@include section-styles(15px, 0px);

section {
  * {
    box-sizing: border-box;
  }
}

@include container-deprecated('.section-inner');

.section-inner {
  /*height: 370px;*/

  &.picture-center {
    position: relative;

    .content {
      position: relative;
      padding: 3em;
      gap: 10px;
      text-shadow: 0 0 1em var(--color-very-light-grey);

      &.text-right {
        .headline, .subheadline, .text-and-links {
          grid-column: 2;
        }
      }
    }

    .media {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
      right: 15px;

      .content-video-pic-container {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr auto auto;
  gap: 20px 30px;
  align-items: end;
  height: 100%;

  .headline, .subheadline, .text-and-links {
    grid-column: 1;
  }

  .media {
    grid-column: 2;
    grid-row: 1 / 4;
    /*align-self: stretch;*/
  }

  .media-video {
    display: grid;
    align-self: center;
  }

  &.content-span-1 {
    grid-template-rows: 1fr;

    .media {
      grid-row: 1;
    }
  }

  &.content-span-2 {
    grid-template-rows: 1fr auto;

    .media {
      grid-row: 1 / 3;
    }
  }
}

.content-video-pic-container, .video {
  display: grid;
  overflow: hidden;
  width: 100%;
  height: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%; /* use object-position to set focus point */
  }
}

.video-button {
  background-color: var(--color-grey);
  color: var(--color-white);
  font-size: var(--font-size-icon-xl);
  line-height: 1;
  font-weight: normal;
  border-radius: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(calc((50% - 15px) * -1), -50%);
  height: 60px;
  width: 60px;
  cursor: pointer;

  &:hover, &:focus {
    background-color: var(--color-dark-grey);
  }
}

.picture-right {
  .headline, .subheadline, .text-and-links {
    margin-right: 40px;
  }
}

.picture-left {
  .video-button {
    transform: translate(calc((50% + 15px) * -1), -50%);
  }

  .headline, .subheadline, .text-and-links {
    grid-column: 2;
    margin-left: 40px;
  }

  .media {
    grid-column: 1;
  }
}

.headline {
  .headline-text {
    @include h1;
    word-wrap: break-word;
  }
}

.subheadline {
  .headline-text {
    @include h3;
  }
}

.headline-text {
  @include text-bold;
  margin: 0;
  padding: 0;
}

.content.font-size-s {
  .headline {
    .headline-text {
      @include h2;
    }
  }

  .subheadline {
    .headline-text {
      @include h3;
    }
  }
}

.text-and-links {
  @include text-main;
  font-size: var(--font-size-sm);

  p, li {
    @include text-main;
    font-size: var(--font-size-sm);
  }

  p {
    margin-top: 15px;
    margin-bottom: 0;
  }

  .button-links {
    list-style: none;
    margin: 30px 0 0 0;
    padding: 0;
    display: flex;
    gap: 10px;
  }
}

.text-right {
  text-align: right;

  .button-links {
    float: right;
  }
}

.text-left {
  text-align: left;

  .button-links {
    float: left;
  }
}

@include media-max-width($breakpoint-xl) {
  .section-inner {
    /*height: 303px;*/
  }

  .content.font-size-s {
    .headline {
      .headline-text {
        @include h3;
      }
    }

    .subheadline {
      .headline-text {
        @include h4;
      }
    }

    .text-and-links {
      font-size: var(--font-size-s);

      p, li {
        font-size: var(--font-size-s);
      }
    }
  }
}

@include media-max-width($breakpoint-l-max-deprecated) {
  .section-inner {
    height: auto;

    &.picture-center {
      .content {
        padding: 0;
      }
      .media {
        position: relative;
        left: 0;
        right: 0;
      }
    }
  }

  .picture-right, .picture-left {
    .headline, .subheadline, .text-and-links {
      margin-right: 0;
      margin-left: 0;
    }
  }

  .video {
    position: relative;
  }

  .video-button, .picture-left {
    .video-button {
      transform: translate(-50%, -50%);
    }
  }

  .text-left, .text-right {
    text-align: left;

    .button-links {
      float: left;
    }
  }

  .content {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 10px;
    text-align: left;

    .headline, .subheadline, .text-and-links, .media {
      grid-column: 1;
      grid-row: auto;
      text-shadow: none;
    }

    &.content-span-1, &.content-span-2 {
      .media {
        grid-row: auto;
      }
    }
  }
}

@include media-max-width($breakpoint-s) {
  .text-and-links {
    .button-links {
      flex-direction: column;
    }
  }
}
